import remove from '../icons/close.svg';

interface FileUploadErrorProps {
  id: string;
  message: string;
  className?: string;
  onDismiss: () => void;
}

function FileUploadError({ id, message, className = '', onDismiss }: FileUploadErrorProps) {
  return (
    <div className={`file-upload-error ${className}`}>
      <p id={id} className="help is-danger error">
        {message}
      </p>
      <div className="remove-ntp-btn" onClick={onDismiss}>
        <img src={remove} alt="remove" className="remove" />
      </div>
    </div>
  );
}

export default FileUploadError;
